import { TMapOffer, TMapOffersResult } from '../../types/common/offer';
import { EMappedTypeOffer } from '../../constants/mapOfferTypes';
import { transformOffers } from './transformOffers';
import { IOfferCardProps } from '../../components/OfferCard';

export function getMapOffers(offers: TMapOffer[], utmTags?: Record<string, string>): TMapOffersResult {
  const arr = [];

  for (let i = 0; i < offers.length; i++) {
    const mappedOfferEntity = offers[i] as TMapOffer;

    if (mappedOfferEntity.items.length > 1) {
      const mappedMultiOffer = mappedOfferEntity.items.map(el => {
        return transformOffers(el, i, utmTags);
      });
      const multi = { type: EMappedTypeOffer.MULTI, content: mappedMultiOffer as IOfferCardProps[] };
      arr.push(multi);
    } else {
      const transformedOffer = transformOffers(mappedOfferEntity.items[0], i, utmTags);
      const offer = { type: EMappedTypeOffer.OFFER, content: transformedOffer as IOfferCardProps };
      arr.push(offer);
    }
  }

  return arr as TMapOffersResult;
}
